import React from 'react'

const Unauthorized = () => {
  return (
    <div>
      <h1>unauthorized access</h1>
    </div>
  )
}

export default Unauthorized
